import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';

const PortfolioSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const projects = [
    {
      title: 'E-commerce Premium',
      category: 'Desenvolvimento Web',
      description: 'Plataforma completa de e-commerce com carrinho, pagamentos e gestão de produtos.',
      image: 'https://cdn.abacus.ai/images/c0310e48-0cd5-4168-ab6a-f13a933cb0c8.png',
      tags: ['Next.js', 'Stripe', 'PostgreSQL', 'Tailwind'],
      color: 'from-blue-600 to-indigo-600',
    },
    {
      title: 'Dashboard Empresarial',
      category: 'Sistema de Gestão',
      description: 'Dashboard analítico com visualização de dados em tempo real e relatórios personalizados.',
      image: 'https://cdn.abacus.ai/images/a41eec2c-5228-4e61-a18f-cd51b96d9b89.png',
      tags: ['React', 'Chart.js', 'API Rest', 'TypeScript'],
      color: 'from-purple-600 to-pink-600',
    },
    {
      title: 'App Mobile Responsivo',
      category: 'Aplicativo Mobile',
      description: 'Aplicativo mobile híbrido com experiência nativa e funcionalidades offline.',
      image: 'https://cdn.abacus.ai/images/ccb34eee-1374-4112-89af-2cebc9142d79.png',
      tags: ['React Native', 'Firebase', 'Redux', 'UI/UX'],
      color: 'from-cyan-600 to-blue-600',
    },
    {
      title: 'Plataforma SaaS',
      category: 'Solução Empresarial',
      description: 'Sistema completo de gestão empresarial com módulos de CRM, projetos e equipes.',
      image: 'https://cdn.abacus.ai/images/1d854901-43a0-4a11-b8c9-53c8253945c6.png',
      tags: ['Next.js', 'Prisma', 'NextAuth', 'Microserviços'],
      color: 'from-emerald-600 to-teal-600',
    },
  ];

  return (
    <section id="portfolio" className="py-24 bg-white" ref={ref} aria-label="Portfólio de Projetos">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-sm font-semibold text-primary-600 uppercase tracking-wide mb-3">
            Portfólio
          </h2>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Projetos que <strong className="text-gradient">inspiram</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Confira alguns dos projetos desenvolvidos para nossos clientes e parceiros.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {projects.map((project, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group bg-gray-50 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="relative aspect-[16/10] bg-gray-200 overflow-hidden">
                <img
                  src={project.image}
                  alt={`${project.title} - ${project.category} desenvolvido pela PixelMatos`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                />
                <div className={`absolute inset-0 bg-gradient-to-br ${project.color} opacity-0 group-hover:opacity-20 transition-opacity duration-300`} />
              </div>

              <div className="p-8">
                <div className="text-sm font-semibold text-primary-600 mb-2">
                  {project.category}
                </div>
                <h4 className="text-2xl font-bold text-gray-900 mb-3">
                  {project.title}
                </h4>
                <p className="text-gray-600 mb-6">
                  {project.description}
                </p>

                <div className="flex flex-wrap gap-2 mb-6">
                  {project.tags.map((tag, idx) => (
                    <span
                      key={idx}
                      className="px-3 py-1 bg-white text-gray-700 text-xs font-medium rounded-full border border-gray-200"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="text-center mt-16"
        >
          <p className="text-gray-600 mb-6">
            Quer ver mais projetos ou discutir o seu?
          </p>
          <button
            onClick={() => document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-gradient-to-r from-primary-600 to-secondary-600 text-white px-10 py-4 rounded-lg font-semibold text-lg shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
          >
            Vamos Conversar
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default PortfolioSection;
